import { ColumnType } from '@/pages/mana/components/Table';
export const getColumns = (
) => {
  const columns: ColumnType<ExamStudentScore>[] = [
    {
      title: '学生姓名',
      dataIndex: 'studentName',
      key: 'studentName'
    },
    // {
    //   title: '县级准考证号',
    //   dataIndex: 'studentExamCard',
    //   key: 'studentExamCard'
    // },
    {
      title: '学校',
      dataIndex: 'studentSchoolName',
      key: 'studentSchoolName'
    },
    {
      title: '班级',
      dataIndex: 'studentClassName',
      key: 'studentClassName'
    },
    {
      title: '总分',
      dataIndex: 'originalScoreTotal',
      key: 'originalScoreTotal',
      render: (_,p) => p.originalScoreTotal === null ? '-' : p.originalScoreTotal
    }
  ];
  return columns;
};
